import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Field } from 'redux-form';

import { TextField, FacebookInput, GuestPasswordField, PasswordField } from '../../components/pbg-ui-library';
import { formatMessage } from '../../../lib/intl';
import reduxFormAdapter from '../../../lib/redux-form-adapter';
import { EMAIL, FACEBOOK, GUEST, INVITEE } from '../../../lib/account-types';

import '../../css/inline-sign-in.css';
import { i18n } from './inline-sign-in.i18n';

class InlineSignIn extends React.PureComponent {
  formatMessage = formatMessage(this.props.intl ? this.props.intl : {});

  static propTypes = {
    accountType: PropTypes.string,
    allowCreateAccount: PropTypes.bool,
    onFacebookClick: PropTypes.func.isRequired,
    onForgotPassword: PropTypes.func.isRequired,
    onSendLink: PropTypes.func.isRequired,
    onSignIn: PropTypes.func.isRequired,
  };

  static defaultProps = {
    accountType: INVITEE,
    allowCreateAccount: true,
  };

  get textInputFacebookProps() {
    const { onFacebookClick } = this.props;

    return {
      icon: 'https://groups-assets.keytravel.com/images/icons/facebook.svg',
      required: true,
      onIconClick: onFacebookClick,
    };
  }

  renderEmailField(props = {}) {
    return (
      <Field
        component={TextField}
        name="email"
        label={this.formatMessage(i18n.emailLabel)}
        placeholder=" "
        hint={this.renderHint()}
        adapter={reduxFormAdapter}
        {...props}
      />
    );
  }

  renderHint() {
    const { accountType, allowCreateAccount, onSignIn } = this.props;
    if (!allowCreateAccount) return null;

    if (accountType === EMAIL) {
      return (
        <React.Fragment>
          {this.formatMessage(i18n.youHaveAnAccount)}
          {' '}
          <span className="pbg-consumer-desktop pbg-desktop-small-link signin-link" onClick={onSignIn}>
            {this.formatMessage(i18n.signIn)}
          </span>
        </React.Fragment>
      );
    }
    if (accountType === FACEBOOK) return this.formatMessage(i18n.emailWasUsedWithFacebook);
    if (accountType === GUEST) return this.formatMessage(i18n.emailBelongsToGuest);
    return this.formatMessage(i18n.emailHint);
  }

  renderAuthenticatorField = () => {
    const { accountType, allowCreateAccount } = this.props;

    if (accountType === FACEBOOK) {
      return this.renderFacebookInput();
    } else if (accountType === GUEST) {
      return this.renderMagickLink();
    } else if (allowCreateAccount) {
      return this.renderGuestPasswordField();
    } else {
      return this.renderPasswordField();
    }
  }

  renderGuestPasswordField = () => {
    const { accountType } = this.props;
    return (
      <Field
        component={GuestPasswordField}
        name="guestPassword"
        placeholder=" "
        label={this.formatMessage(i18n.createPasswordLabel)}
        hint={this.formatMessage(i18n.createPasswordHint)}
        adapter={reduxFormAdapter}
        disabled={accountType === EMAIL}
        required
      />
    );
  }

  renderFacebookInput = () => {
    const { onFacebookClick } = this.props;

    return (
      <FacebookInput
        buttonLabel={this.formatMessage(i18n.continueWithFacebookLabel)}
        hint={this.formatMessage(i18n.continueWithFacebookHint)}
        onClick={onFacebookClick}
      />
    );
  }

  renderMagickLink = () => {
    const { onSendLink } = this.props;

    return (
      <p className="magic-link-text pbg-consumer-desktop pbg-desktop-small-text pbg-desktop-paragraph-secondary">
        {this.formatMessage(i18n.magicLinkInstructions)}
        {' '}
        <span className="pbg-consumer-desktop pbg-desktop-small-link" onClick={onSendLink}>
          {this.formatMessage(i18n.sendMeALink)}
        </span>
      </p>
    );
  }

  renderPasswordField = () => {
    const { onForgotPassword } = this.props;

    return (
      <Field
        component={PasswordField}
        name="password"
        label={this.formatMessage(i18n.enterPasswordLabel)}
        placeholder=" "
        hint={this.formatMessage(i18n.enterPasswordHint)}
        forgotPasswordText={this.formatMessage(i18n.enterPasswordForgot)}
        onForgotPassword={onForgotPassword}
        adapter={reduxFormAdapter}
        required
      />
    );
  }

  render() {
    const { accountType } = this.props;
    const useFBTypes = [INVITEE];
    const emailProps = useFBTypes.indexOf(accountType) > -1 ? this.textInputFacebookProps : {};

    return (
      <div className="inline-sign-in row">
        <div className="col-6">
          {this.renderEmailField(emailProps)}
        </div>
        <div className="col-6">
          {this.renderAuthenticatorField()}
        </div>
      </div>
    );
  }
}

export default injectIntl(InlineSignIn);



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/inline-sign-in.js